import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function useContas() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [newName, setNewName] = useState("");
  const [newType, setNewType] = useState("bank");

  const fetchAccounts = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get("/financiero/accounts");
      setAccounts(res.data);
    } catch {} finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetchAccounts(); }, [fetchAccounts]);

  const createAccount = async () => {
    if (!newName) return;
    try {
      await authAxios.post(`/financiero/accounts?name=${encodeURIComponent(newName)}&type=${newType}`);
      toast.success("Cuenta creada");
      setShowNew(false);
      setNewName("");
      fetchAccounts();
    } catch {
      toast.error("Error");
    }
  };

  return { accounts, loading, showNew, setShowNew, newName, setNewName, newType, setNewType, createAccount };
}
